<div
  class="ripple-container"
  matRipple
  [class.disabled]="disabled$ | async"
  (click)="onBtnClick()"
>
  <mat-icon>
    person_add
  </mat-icon>
  Add to pool
</div>
